module.exports = __webpack_public_path__ + "img/congress of sages.7afab65f.png";